//根据color颜色渲染不同srgb背景
/*srgb不准确 渲染3d文件、加载颜色列表参数都为background*/
function getColorByName(name, title) {
  console.log(name);
  var sRGB = "";
  var background = "";
  var backgroundImage = "";
  name = name.toUpperCase();
  switch (name) {
    case "MISMATCHED DESIGN. L/R COLORS VARY.":
      {
        sRGB = "";
        background = "linear-gradient(135deg,rgb(245, 96, 4) 50%,rgb(18, 31, 214) 50%)";
      }
      break;
    case "ULTRA BLUE":
      {
        sRGB = "";
        background = "linear-gradient(135deg, rgba(49, 201, 243, 1) 50%, #9bfff0ff 50%)";
      }
      break;
    case "ION STORM":
      {
        sRGB = "";
        background = "linear-gradient(135deg, #99A0BC 50%, #66B7CE 50%)";
      }
      break;
      case "THE HIDDEN GEM":
      {
        sRGB = "";
        background = "linear-gradient(135deg, #000000 50%, #E5D674 50%)";
      }
      break;
      case "IVY":
      {
        sRGB = "";
        background = "linear-gradient(135deg, #E8E5DD 50%, #738D7E 50%)";
      }
      break;
      case "JOKER":
      {
        sRGB = "";
        background = "linear-gradient(135deg, #FFC9FF 50%, #FFFC41 50%)";
      }
      break;
      case "LEOPARD":
      {
        sRGB = "";
        background = "linear-gradient(135deg, #C6DFC1 50%, #CBA788 50%)";
      }
      break;
      case "LUNAR GLEAM":
      {
        sRGB = "";
        background = "linear-gradient(135deg, #F7F7F7 50%, #66B7CE 50%)";
      }
      break;
      case "STRAWBERRY":
      {
        sRGB = "";
        background = "linear-gradient(135deg, #EBC9C4 50%, #F1EFDD 50%)";
      }
      break;
      case "LIGHTBURST":
      {
        sRGB = "";
        background = "linear-gradient(135deg, #d5f459ff 50%, #ccb9edff 50%)";
      }
      break;
    case "AZURE VEIL":
      {
        sRGB = "";
        background = "#86edffff";
      }
      break;
    case "QUARTZ BLUSH":
      {
        sRGB = "";
        background = "#fdb5daff";
      }
      break;
    case "BATTLE GROUND":
      {
        sRGB = "";
        background = "#D3D5CA";
      }
      break;
    case "BUBBLE GUM":
      {
        sRGB = "";
        background = "#F4DCE7";
      }
      break;
    case "HUNTER GREY":
      {
        sRGB = "";
        background = "#999598";
      }
      break;
    case "MOUNTAIN TAUPE":
      {
        sRGB = "";
        background = "#E4D7C5";
      }
      break;
    case "LYNX":
      {
        sRGB = "";
        background = "#717072";
      }
      break;
    case "猞猁":
      {
        sRGB = "";
        background = "#717072";
      }
      break;
    case "WHITE GARDENIA":
      {
        sRGB = "";
        background = "#ffffff";
      }
      break;
    case "BEIGE":
      {
        sRGB = "";
        background = "#E7D9B0";
      }
      break;
    case "ALYSSUM":
      {
        sRGB = "";
        background = "#E6E4DE";
      }
      break;
    case "WHITE":
      {
        sRGB = "";
        background = "#ffffff";
      }
      break;
    case "PHANTOM":
      {
        sRGB = "";
        background = "#000000";
      }
      break;
    case "DARK PHANTOM":
      {
        sRGB = "";
        background = "#000000";
      }
      break;
    case "白鬼":
      {
        sRGB = "";
        background = "#ffffff";
      }
      break;
    case "BLACK":
      {
        sRGB = "";
        background = "#000000";
      }
      break;
    case "PHANTOM BLUE":
      {
        sRGB = "";
        background = "linear-gradient(135deg, #ffffff 50%, #004DD6 50%)";
      }
      break;
       case "EQLZ®247 JLEW":
      {
        sRGB = "";
        background = "linear-gradient(135deg, #ffffff 50%, #004DD6 50%)";
        backgroundImage = "https://cdn.shopify.com/s/files/1/0637/6321/8685/files/JLEW_247.jpg?v=1749391617";
      }
      break;
       case "BATTLEGROUND":
      {
        sRGB = "";
        background = "";
        backgroundImage = "https://cdn.shopify.com/s/files/1/0637/6321/8685/files/EQ253140-2_5e42c3c0-5571-4e50-9041-b7e3e14d94e1.jpg?v=1769864827";
      }
      break;
       case "AURA":
      {
        sRGB = "";
        background = "";
        backgroundImage = "https://cdn.shopify.com/s/files/1/0637/6321/8685/files/AURA_color.jpg?v=1782714681";
      }
      break;
         case "EQLZ®360 JLEW":
      {
        sRGB = "";
        background = "linear-gradient(135deg, #ffffff 50%, #004DD6 50%)";
        backgroundImage = "https://cdn.shopify.com/s/files/1/0637/6321/8685/files/JLEW_360.jpg?v=1749391557";
      }
      break;
       case "EQLZ®247 NATE ROBINSON":
      {
        sRGB = "";
        background = "";
        backgroundImage = "https://cdn.shopify.com/s/files/1/0637/6321/8685/files/nate_247.jpg?v=1749392064";
      }
      break;
      case "EQLZ®360 NATE ROBINSON":
      {
        sRGB = "";
        background = "";
        backgroundImage = "https://cdn.shopify.com/s/files/1/0637/6321/8685/files/nate_360.jpg?v=1749392209";
      }
      break;
    case "ファントム・ブルー":
      {
        sRGB = "";
        background = "linear-gradient(135deg, #ffffff 50%, #004DD6 50%)";
      }
      break;
    case "MOON WHITE":
      {
        sRGB = { r: 255 / 255.0, g: 255 / 255.0, b: 255 / 255.0 };
        background = "#ffffff";
      }
      break;
    case "月白":
      {
        sRGB = { r: 255 / 255.0, g: 255 / 255.0, b: 255 / 255.0 };
        background = "#ffffff";
      }
      break;
    case "NEBULA GREEN":
      {
        sRGB = "";
        background = "linear-gradient(135deg, #5B8E95 50%, #D7D8D9 50%)";
      }
      break;
    case "星雲緑":
      {
        sRGB = "";
        background = "linear-gradient(135deg, #5B8E95 50%, #D7D8D9 50%)";
      }
      break;
    case "NEBULA SOLAR":
      {
        sRGB = "";
        background = "linear-gradient(135deg, #BA7843 50%, #D7D8D9 50%)";
      }
      break;
    case "星雲橙":
      {
        sRGB = "";
        background = "linear-gradient(135deg, #BA7843 50%, #D7D8D9 50%)";
      }
      break;
    case "PHANTOM/ZOMBIE":
      {
        sRGB = "";
        background = "linear-gradient(135deg, #ffffff 50%, #000000 50%)";
      }
      break;
    case "SOURCE CODE":
      {
        sRGB = "";
        background = "linear-gradient(135deg, #ffffff 50%, #000000 50%)";
      }
      break;
    case "鬼白":
      {
        sRGB = "";
        background = "linear-gradient(135deg, #ffffff 50%, #000000 50%)";
      }
      break;
    case "CONCRETE BLACK":
      {
        sRGB = "";
        background = "linear-gradient(135deg, #000000 50%, #C2C4C3 50%)";
      }
      break;
    case "CONCRETE GRAY":
      {
        sRGB = "";
        background = "linear-gradient(135deg, #A9ABAF 50%, #ffffff 50%)";
      }
      break;
    case "CAMPUS RED":
      {
        sRGB = "";
        background = "linear-gradient(135deg, #FFFFFF 50%, #621C27 50%)";
      }
      break;
    case "CAMPUS BLUE":
      {
        sRGB = "";
        background = "linear-gradient(135deg, #FFFFFF 50%, #172D4E 50%)";
      }
      break;
    case "URBAN BLACK":
      {
        sRGB = "";
        background = "linear-gradient(135deg, #FFFFFF 50%, #000000 50%)";
      }
      break;
    case "ECLIPSE":
      {
        sRGB = "";
        background = "linear-gradient(135deg, #000000 50%, #FFFFFF 50%)";
      }
      break;
    case "日蝕":
      {
        sRGB = "";
        background = "linear-gradient(135deg, #000000 50%, #FFFFFF 50%)";
      }
      break;
    case "GINGKO YELLOW":
      {
        sRGB = "";
        background = "linear-gradient(135deg, #DCD7CC 50%, #E0CA80 50%)";
      }
      break;
    case "DAYDREAM":
      {
        sRGB = "";
        background = "linear-gradient(135deg, #DAADA5 50%, #B7BEB3 50%)";
      }
      break;
    case "MAKO":
      {
        sRGB = "";
        background = "#385B81";
      }
      break;
    case "鯖鯊青":
      {
        sRGB = "";
        background = "#385B81";
      }
      break;
    case "MOSS GREEN":
      {
        sRGB = "";
        background = "#4D5450";
      }
      break;
    case "EARTH GREEN":
      {
        sRGB = "";
        background = "#36564B";
      }
      break;
    case "大地緑":
      {
        sRGB = "";
        background = "#36564B";
      }
      break;
    case "BLACK JADE":
      {
        sRGB = "";
        background = "#000000";
      }
      break;
    case "墨玉":
      {
        sRGB = "";
        background = "#000000";
      }
      break;
    case "BLACK MYTH":
      {
        sRGB = "";
        background = "#000000";
      }
      break;
    case "暗夜黒":
      {
        sRGB = "";
        background = "#000000";
      }
      break;
    case "BLACK":
      {
        sRGB = "";
        background = "#000000";
      }
      break;
    case "SAND":
      {
        sRGB = "";
        background = "#DCD0BC";
      }
      break;
    case "砂灰":
      {
        sRGB = "";
        background = "#DCD0BC";
      }
      break;
    case "WHITE JADE":
      {
        sRGB = "";
        background = "#DEE9CF";
      }
      break;
    case "WHITE GARDENIA":
      {
        sRGB = { r: 255 / 255.0, g: 255 / 255.0, b: 255 / 255.0 };
        background = "#ffffff";
      }
      break;
    case "BLACK FOG":
      {
        sRGB = "";
        background = "#000000";
      }
      break;
    case "SNOW LEOPARD":
      {
        sRGB = "";
        background = "#ffffff";
      }
      break;
    case "WHITE CORAL":
      {
        sRGB = {};
        background = "#eeeeea";
      }
      break;
    case "BLACK ONYX":
      {
        sRGB = "";
        background = "#000000";
      }
      break;
    case "KAPOK":
      {
        sRGB = { r: 215 / 255.0, g: 212 / 255.0, b: 185 / 255.0 };
        background = "#E0DCC6";
      }
      break;
    case "SHADOW":
      {
        sRGB = { r: 138 / 255.0, g: 115 / 255.0, b: 119 / 255.0 };
        background = "#99958D";
      }
      break;
    case "MUSHROOM":
      {
        sRGB = { r: 212 / 255.0, g: 216 / 255.0, b: 213 / 255.0 };
        background = "#D2D6D3";
      }
      break;
    case "ASH":
      {
        sRGB = { r: 224 / 255.0, g: 224 / 255.0, b: 213 / 255.0 };
        background = "#DEDED3";
      }
      break;
    case "BREEZE":
      {
        sRGB = { r: 218 / 255.0, g: 239 / 255.0, b: 232 / 255.0 };
        background = "#bcdce8";
      }
      break;
    case "LIMECREAM":
      {
        sRGB = { r: 220 / 255.0, g: 233 / 255.0, b: 190 / 255.0 };
        background = "#D7DDC5";
      }
      break;
    case "HAZE":
      {
        sRGB = { r: 176 / 255.0, g: 204 / 255.0, b: 195 / 255.0 };
        background = "#ABCDCE";
      }
      break;
    case "PEACH":
      {
        sRGB = { r: 245 / 255.0, g: 185 / 255.0, b: 149 / 255.0 };
        background = "#E8BDA0";
      }
      break;
    case "CRESCENT":
      {
        sRGB = { r: 119 / 255.0, g: 131 / 255.0, b: 158 / 255.0 };
        background = "#77819C";
      }
      break;
    case "LICHEN":
      {
        sRGB = { r: 208 / 255.0, g: 196 / 255.0, b: 86 / 255.0 };
        background = "#eddb5d";
      }
      break;
    case "GHOST":
      {
        sRGB = { r: 62 / 255.0, g: 64 / 255.0, b: 67 / 255.0 };
        background = "#262728";
      }
      break;
    case "MAGMA":
      {
        sRGB = { r: 255 / 255.0, g: 123 / 255.0, b: 37 / 255.0 };
        background = "#F27F4C";
      }
      break;
    case "SNOWLION":
      {
        sRGB = "";
        background = "#f7f7f0";
      }
      break;
    case "雪獅":
      {
        sRGB = "";
        background = "#f7f7f0";
      }
      break;
    case "LYNX":
      {
        sRGB = { r: 82 / 255.0, g: 82 / 255.0, b: 87 / 255.0 };
        background = "#525257";
      }
      break;
    case "PANTHER":
      {
        sRGB = { r: 62 / 255.0, g: 64 / 255.0, b: 67 / 255.0 };
        // background = "#3E4043";
        background = "#000000";
      }
      break;
    case "黒豹":
      {
        sRGB = { r: 62 / 255.0, g: 64 / 255.0, b: 67 / 255.0 };
        // background = "#3E4043";
        background = "#000000";
      }
      break;
    case "THIRD EYE TIGER":
      {
        sRGB = { r: 247 / 255.0, g: 91 / 255.0, b: 59 / 255.0 };
        background = "#f48547";
      }
      break;
    case "GAEA":
      {
        sRGB = "";
        if (title.indexOf("1980") != -1) {
          background = "linear-gradient(135deg, #B9C9CA 50%, #4B3F4E 50%)";
        } else if (title.indexOf("FAULT") != -1) {
          background = "linear-gradient(135deg, #9E9E9A 50%, #27292B 50%)";
        } else if (title.indexOf("2023") != -1) {
          background = "linear-gradient(135deg, #9C9D8C 50%, #151513 50%)";
        } else background = "#DEDED3";
      }
      break;
    case "SNOWBERG":
      {
        sRGB = "";
        background = "linear-gradient(135deg, #e4dfd3 50%, #3d3c40 50%)";
      }
      break;
    case "MOSS GRAY":
      {
        sRGB = "";
        background = "#8c8f85";
      }
      break;
    case "ZOMBIE":
      {
        sRGB = "";
        background = "#ffffff";
      }
      break;
    case "MIRAGE":
      {
        sRGB = "";
        background = "#a2a5ad";
      }
      break;
    default:
      break;
  }
  return { sRGB: sRGB, background: background,backgroundImage:backgroundImage };
}
